import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Initialize Sentry as early as possible
import { initializeSentry } from "./sentry.config";

// Capture fbclid from URL on landing (Meta Ads click tracking)
import { captureRegistrationSource } from "./utils/registrationSourceParams";
import { captureFbclid } from "./services/metaPixelService";

// Redirect legacy tenant subdomains (e.g. krawatimuszka.kiedynabory.pl) to app.kiedynabory.pl.
// Required because legacy subdomains are not in Cloudflare Turnstile allowed domains (Error 110200).
// Uses replace() (not href=) to avoid adding the legacy URL to browser history.
// KN-only: getLegacyRedirectUrl returns null for non-*.kiedynabory.pl hosts,
// so this is a safe no-op for Hotel B2B and custom tenant domains.
import { getLegacyRedirectUrl } from "./utils/legacySubdomainRedirect";

const legacyRedirectUrl = getLegacyRedirectUrl(
  window.location.hostname,
  window.location.pathname,
  window.location.search
);
if (legacyRedirectUrl) {
  window.location.replace(legacyRedirectUrl);
} else {
  initializeSentry();
  // First entry of the session: keep UTM/click IDs before the SPA navigates away.
  captureRegistrationSource();
  captureFbclid();

  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
}
